<template>
	<!-- 一图读懂 -->
	<div class="quarter-card" v-if="quarterDetails.longImage" @click="previewCover">
		<h4>
			{{ $t('enterprise.page-version') }}
		</h4>
		<div class="roadshow-box flex-space-between">
			<p class="roadshow-title">{{ quarterDetails.announcementTitle }}</p>
			<img class="roadshow-img" :src="quarterDetails.longImage" alt="" />
		</div>
	</div>
</template>

<script setup>
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';

const props = defineProps({
	quarterDetails: {
		type: Object,
		required: true
	}
});

const { viewModule } = useModuleNavigation();
const previewCover = () => {
	viewModule('quarterly_performance_image_preview', { url: props.quarterDetails.longImage });
};
</script>

<style lang="less" scoped>
.quarter-card {
	margin-bottom: 12px;
	padding: 16px;
	border-radius: 6px;
	background: #fff;
	h4 {
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: var(--t-emphasis-color, #1d2129);

		font-size: 16px;
		font-weight: 500;
		line-height: 24px; /* 150% */
	}

	.roadshow-box {
		padding-top: 14px;
		display: flex;
		align-items: flex-start;
		gap: 8px;
		.roadshow-title {
			color: var(---__black_text, #12121a);
			font-size: 15px;
			font-weight: 500;
			line-height: 24px; /* 160% */
		}
		.roadshow-img {
			width: 100px;
			height: 75px;
			border-radius: 4px;
			object-fit: cover;
		}
	}
	.flex-space-between {
		justify-content: space-between;
	}
}
</style>
